// =====================================================
// ẢNH ĐẠI DIỆN BẤM VÀO XEM TO ĐƯỢC
// File: web-app/src/components/AvatarXem.js
//
// Dùng chung cho mọi chỗ hiện ảnh đại diện: hồ sơ của mình, đầu khung chat,
// từng bong bóng tin nhắn trong nhóm, danh sách thành viên nhóm.
//
// Chưa đặt ảnh thì hiện chữ cái đầu tên như cũ và KHÔNG bấm được — không có
// gì để xem, bấm ra màn hình đen thì khó hiểu.
//
// CẢ PHẦN MỀM CHỈ CÓ ĐÚNG MỘT KHUNG XEM (AvatarPreviewHost, gắn ở App.js).
// Ban đầu mỗi ảnh tự dựng một khung riêng, hậu quả là bấm ảnh người này rồi
// bấm ảnh người kia thì HAI khung chồng lên nhau và hiện nhầm ảnh.
// =====================================================
import React, { useState, useEffect } from 'react';
import { Avatar, Image } from 'antd';
import { fileUrl } from '../utils/fileUrl';
import { anhGocTuNho } from '../utils/anhDaiDien';   // avatar_url là bản nhỏ; xem lớn thì mở ảnh gốc nét nhất

// Màu nền theo tên cho dễ phân biệt — cùng một người luôn ra cùng một màu
const MAU = ['#1677ff', '#52c41a', '#fa8c16', '#eb2f96', '#722ed1', '#13c2c2', '#f5222d'];
export const mauTheoTen = (s) => MAU[(String(s || '').charCodeAt(0) || 0) % MAU.length];
export const chuDauTen = (s) =>
    String(s || '?').trim().split(/\s+/).slice(-1)[0].charAt(0).toUpperCase();

// Cầu nối tới khung xem duy nhất
let moKhungXem = null;
export const xemAnhDaiDien = (src, alt) => {
    if (moKhungXem && src) moKhungXem(src, alt);
};

// Khung xem ảnh dùng chung — gắn MỘT LẦN ở App.js
export const AvatarPreviewHost = () => {
    const [st, setSt] = useState({ mo: false, src: null, alt: '' });

    useEffect(() => {
        moKhungXem = (src, alt) => setSt({ mo: true, src, alt: alt || 'Ảnh đại diện' });
        return () => { moKhungXem = null; };
    }, []);

    if (!st.src) return null;
    return (
        <Image
            src={st.src} alt={st.alt}
            style={{ display: 'none' }}
            preview={{
                visible: st.mo,
                src: st.src,
                onVisibleChange: (v) => setSt(s => ({ ...s, mo: v }))
            }}
        />
    );
};

const AvatarXem = ({
    url,          // đường dẫn ảnh đại diện (có thể rỗng)
    name,         // tên, dùng để lấy chữ cái đầu + màu nền
    size = 32,
    style,
    xem = true,   // cho phép bấm xem to không
    onClick       // nếu chỗ gọi muốn tự xử lý cú bấm (VD mở cuộc trò chuyện)
}) => {
    const src = fileUrl(url);
    const bamDuoc = xem && !!src;

    const bam = (e) => {
        if (onClick) return onClick(e);
        if (!bamDuoc) return;
        // Chặn lan ra ngoài: bấm ảnh trong khung chat không được kéo theo
        // hành động của cả dòng (mở hội thoại, mở thông tin nhóm...)
        e.stopPropagation();
        xemAnhDaiDien(anhGocTuNho(src), name);
    };

    if (src) {
        return (
            <Avatar
                size={size} src={src} onClick={bam}
                style={{ ...style, cursor: (bamDuoc || onClick) ? 'pointer' : undefined }}
            />
        );
    }
    return (
        <Avatar
            size={size} onClick={onClick ? bam : undefined}
            style={{ background: mauTheoTen(name), ...style, cursor: onClick ? 'pointer' : undefined }}
        >
            {chuDauTen(name)}
        </Avatar>
    );
};

export default AvatarXem;
